import { createGtm } from "@gtm-support/vue-gtm";

// No Subresource Integrity hash is added for the GTM script this library
// loads (googletagmanager.com/gtm.js?id=...): its content is a live,
// account-specific tag configuration that Google/marketers update without a
// portal deploy, so any pinned hash would break on the vendor's next change
// — SRI is only valid for a resource whose bytes are fixed at a given URL.
// Self-hosting is not practical either, since that would require mirroring
// GTM's tag configuration ourselves. The compensating control is the CSP
// script-src allowlist in nuxt.config.ts (exact host, 'strict-dynamic') —
// see that file and the accompanying security report for detail.
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(
    createGtm({
      id: useRuntimeConfig().public.gtmId,
      defer: false,
      compatibility: false,
      enabled: true,
      debug: true,
      loadScript: true,
      vueRouter: useRouter(),
      trackOnNextTick: false,
    })
  );
});
